import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { OrdersService } from '../../services/orders.service';
import { AuditLogEntry } from '../../models/audit-log.model';

@UntilDestroy()
@Component({
  selector: 'app-audit-log-modal',
  templateUrl: './audit-log-modal.component.html',
  styleUrls: ['./audit-log-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AuditLogModalComponent implements OnInit {
  orderId: number;

  isLoading = true;
  errorMessage: string | null = null;
  auditLogs: AuditLogEntry[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private ordersService: OrdersService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadAuditLogs();
  }

  private loadAuditLogs(): void {
    this.isLoading = true;
    this.errorMessage = null;

    this.ordersService.getAuditLogs(this.orderId).pipe(
      catchError(error => {
        console.error('Error loading audit logs:', error);
        this.errorMessage = 'Failed to load audit logs.';
        return of([] as AuditLogEntry[]);
      }),
      untilDestroyed(this)
    ).subscribe(auditLogs => {
      this.auditLogs = [...auditLogs].sort(
        (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      );
      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }

  formatDateTime(dateTime: string): string {
    return new Date(dateTime).toLocaleString(undefined, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  getFullName(log: AuditLogEntry): string {
    const name = log.userName;
    if (!name) {
      return '-';
    }
    if (name.includes(',')) {
      const [lastName, firstName] = name.split(',').map(part => part.trim());
      return firstName && lastName ? `${firstName} ${lastName}` : name;
    }
    return name;
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
